(function () {
  'use strict';

  var STATES = ['verfrist', 'verwarmt', 'verkoelt'];

  // Background colors per state (matches data-background-color on SVG paths)
  var BG_COLORS = {
    verwarmt: '#C82D00',
    verkoelt: '#000000',
    verfrist: '#262794'
  };

  function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  function initWheel(wheel) {
    var svg = wheel.querySelector('[data-wheel-svg]');
    if (!svg) return;

    var intervalMs = (parseFloat(wheel.dataset.time) || 5) * 1000;
    var currentState = wheel.dataset.wheelState || 'verfrist';
    var currentRotation = 0;
    var cycleTimer = null;

    function switchState(name) {
      if (name === currentState) return;

      // Rotate SVG by 120° per transition (cumulative spin)
      currentRotation += 120;
      svg.style.transform = 'rotate(' + currentRotation + 'deg)';

      // SVG active class controls arc fill + label colors
      svg.setAttribute('class', 'is-active-' + name);

      // Section background color fallback (visible when no image)
      if (BG_COLORS[name]) {
        wheel.style.backgroundColor = BG_COLORS[name];
      }

      // Background images
      wheel.querySelectorAll('.wheel2__backgrounds img').forEach(function (img) {
        img.classList.remove('is-active');
      });
      var activeImg = wheel.querySelector('.' + name + '-image');
      if (activeImg) activeImg.classList.add('is-active');

      // Outline arc: is-current-active marks the active segment
      wheel.querySelectorAll('#Outline path').forEach(function (p) {
        p.classList.remove('is-current-active');
      });
      var outlinePath = wheel.querySelector('#' + capitalize(name) + '-background');
      if (outlinePath) outlinePath.classList.add('is-current-active');

      // Label text groups
      wheel.querySelectorAll('#line-text > g').forEach(function (g) {
        g.classList.remove('is-current-active');
      });
      var textGroup = wheel.querySelector('#' + capitalize(name) + '-text');
      if (textGroup) textGroup.classList.add('is-current-active');

      // Tab panels
      wheel.querySelectorAll('[data-tab]').forEach(function (tab) {
        tab.classList.toggle('is-active', tab.dataset.tab === name);
      });

      // Section root class (used for future CSS hooks if needed)
      wheel.className = wheel.className
        .replace(/\bis-active-element-\S+/g, '')
        .trim() + ' is-active-element-' + name;

      currentState = name;
    }

    function getNextState() {
      var idx = STATES.indexOf(currentState);
      return STATES[(idx + 1) % STATES.length];
    }

    function startCycle() {
      if (cycleTimer) clearTimeout(cycleTimer);
      cycleTimer = setTimeout(function tick() {
        switchState(getNextState());
        cycleTimer = setTimeout(tick, intervalMs);
      }, intervalMs);
    }

    // Click on SVG outline arcs
    wheel.querySelectorAll('#Outline path').forEach(function (path) {
      path.addEventListener('click', function () {
        var name = this.dataset.name;
        if (name && name !== currentState) {
          switchState(name);
          startCycle(); // restart timer from this point
        }
      });
    });

    startCycle();
  }

  function init() {
    document.querySelectorAll('[data-wheel]').forEach(function (wheel) {
      initWheel(wheel);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
